(function () {
  var STORAGE_KEY = 'lamp-lighting-toggle:on';
  var READY_CLASS = 'lighting-toggle--alt-ready';
  var root = document.documentElement;
  var fadeTimer;
  var pending = new WeakSet();
  var DEBUG = /[?&]lt_debug=1\b/.test(window.location.search);

  function debugLog(message) {
    if (DEBUG) console.log('[Light toggle] ' + message);
  }

  function getInputs() {
    return document.querySelectorAll('[data-lighting-toggle-input]');
  }

  function isActive() {
    return getInputs().length > 0;
  }

  function markReady(img) {
    if (!isActive()) return;

    var wrapper = img.closest(
      '.CollectionInner .ProductItem__ImageWrapper--withAlternateImage'
    );

    if (wrapper) wrapper.classList.add(READY_CLASS);
  }

  function isImgLoaded(img) {
    return img.complete && img.naturalWidth > 0;
  }

  function manuallyResolveImage(img) {
    if (!isActive()) return;

    if (isImgLoaded(img)) {
      markReady(img);
      return;
    }

    var dataSrc = img.getAttribute('data-src');
    if (!dataSrc) return;

    var wrapper = img.closest('.ProductItem__ImageWrapper');
    var widthGuess =
      (wrapper && wrapper.getBoundingClientRect().width) ||
      img.getBoundingClientRect().width ||
      700;

    if (widthGuess < 100) widthGuess = 700;

    var width = Math.min(
      Math.round(widthGuess * (window.devicePixelRatio || 1)),
      1200
    );

    var resolvedSrc = dataSrc.replace('{width}', width);

    img.addEventListener('load', function () {
      markReady(img);
    }, { once: true });

    img.addEventListener('error', function () {
      debugLog('Billedet kunne ikke indlæses: ' + resolvedSrc);
    }, { once: true });

    img.removeAttribute('data-src');
    img.src = resolvedSrc;
  }

  function ensureAlternateImagesLoaded() {
    if (!isActive()) return;

    var images = document.querySelectorAll(
      '.CollectionInner ' +
      '.ProductItem__ImageWrapper--withAlternateImage ' +
      '.ProductItem__Image--alternate'
    );

    images.forEach(function (img) {
      if (isImgLoaded(img)) {
        markReady(img);
        return;
      }

      if (pending.has(img)) return;
      pending.add(img);

      img.addEventListener('load', function () {
        pending.delete(img);
        markReady(img);
      }, { once: true });

      img.addEventListener('error', function () {
        pending.delete(img);
      }, { once: true });

      if (
        window.lazySizes &&
        window.lazySizes.loader &&
        typeof window.lazySizes.loader.unveil === 'function'
      ) {
        window.lazySizes.loader.unveil(img);
      }

      window.setTimeout(function () {
        manuallyResolveImage(img);
      }, 200);
    });
  }

  function applyState(isOn) {
    if (!isActive()) {
      root.classList.remove(
        'lighting-toggle-page',
        'lights-on',
        'lighting-is-switching'
      );
      return;
    }

    root.classList.add('lighting-toggle-page');
    root.classList.toggle('lights-on', isOn);

    getInputs().forEach(function (input) {
      input.checked = isOn;
    });

    debugLog(isOn ? 'Tændt' : 'Slukket');

    if (isOn) ensureAlternateImagesLoaded();
  }

  function storeState(isOn) {
    try {
      localStorage.setItem(STORAGE_KEY, isOn ? '1' : '0');
    } catch (error) {
      // Funktionen virker også uden adgang til localStorage.
    }
  }

  function readStoredState() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function init() {
    // Ingen lyskontakt: ingen ændring af produktbilleder.
    if (!isActive()) {
      root.classList.remove(
        'lighting-toggle-page',
        'lights-on',
        'lighting-is-switching'
      );
      return;
    }

    root.classList.add('lighting-toggle-page');

    document.addEventListener('lazyloaded', function (event) {
      var img = event.target;

      if (
        img &&
        img.classList &&
        img.classList.contains('ProductItem__Image--alternate') &&
        isImgLoaded(img)
      ) {
        markReady(img);
      }
    });

    applyState(readStoredState());

    // Gør billederne klar til både hover og toggle.
    ensureAlternateImagesLoaded();

    document.addEventListener('change', function (event) {
      if (
        !event.target.matches('[data-lighting-toggle-input]') ||
        !isActive()
      ) {
        return;
      }

      clearTimeout(fadeTimer);
      root.classList.add('lighting-is-switching');

      // Registrer udgangspunktet før billedets opacity ændres.
      var image = document.querySelector(
        '.CollectionInner .lighting-toggle--alt-ready .ProductItem__Image'
      );

      if (image) {
        window.getComputedStyle(image).opacity;
        image.getBoundingClientRect();
      }

      var isOn = event.target.checked;
      applyState(isOn);
      storeState(isOn);

      fadeTimer = window.setTimeout(function () {
        root.classList.remove('lighting-is-switching');
      }, 550);
    });

    var grid = document.querySelector('.CollectionInner');

    if (grid && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        if (!isActive()) {
          applyState(false);
          return;
        }

        ensureAlternateImagesLoaded();
      });

      observer.observe(grid, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
